import classNames from 'clsx';
import React from 'react';

import FormattedDateTime from '../FormattedDateTime/FormattedDateTime';

import styles from './MeetingBasedDescription.scss';

export interface MeetingBasedDescriptionProps {
  className?: string;
  venue?: string;
  marketTime?: string;
  description?: string;
  variant?: 'link';
}

export const MeetingBasedDescription: React.FC<MeetingBasedDescriptionProps> = ({
  className,
  venue,
  marketTime,
  description,
  variant
}) => {
  const hasDescription = variant !== 'link';

  return (
    <span className={className}>
      {hasDescription ? description : null}
      {venue && marketTime ? (
        <span
          className={classNames({
            [styles.newLine]: hasDescription
          })}
        >
          {venue}
          {' - '}
          <FormattedDateTime date={marketTime} />
        </span>
      ) : null}
    </span>
  );
};
